import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gradient-to-br from-[#0A5F7F] to-[#0D7FA3] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img src="/images/logo.png" alt="Consulting Logistic Favicon" className="h-10 w-10 object-contain" />
              </div>
              <div>
                <span className="font-bold text-lg">Consulting Logistic</span>
                <p className="text-sm text-white/80">S.A.</p>
              </div>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <span className="font-semibold text-lg mb-4 block">{t('footer.quickLinks')}</span>
            <div className="space-y-2">
              <Link to="/quienes-somos" className="block text-white/80 hover:text-white transition-colors text-sm">
                {t('nav.about')}
              </Link>
              <Link to="/servicios" className="block text-white/80 hover:text-white transition-colors text-sm">
                {t('nav.services')}
              </Link>
              <Link to="/capacitacion" className="block text-white/80 hover:text-white transition-colors text-sm">
                {t('nav.training')}
              </Link>
              <Link to="/sostenibilidad" className="block text-white/80 hover:text-white transition-colors text-sm">
                {t('nav.sustainability')}
              </Link>
              <Link to="/sectores" className="block text-white/80 hover:text-white transition-colors text-sm">
                {t('nav.sectors')}
              </Link>
            </div>
          </div>

          <div>
            <span className="font-semibold text-lg mb-4 block">{t('footer.contact')}</span>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span className="text-white/80 text-sm">info@consulogic-gt.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span className="text-white/80 text-sm">{t('footer.location')}</span>
              </div>
            </div>
          </div>

          <div>
            <span className="font-semibold text-lg mb-4 block">{t('footer.follow')}</span>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/consulogic-gt" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.facebook.com/consulting.logistic.sa" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            {t('footer.rights')}
          </p>
          <div className="flex gap-4 opacity-40 hover:opacity-100 transition-opacity duration-500">
            <Link to="/equipo" className="text-white/40 hover:text-white text-[10px] uppercase tracking-widest font-bold">
              Portal Equipo
            </Link>
            <Link to="/admin" className="text-white/40 hover:text-white text-[10px] uppercase tracking-widest font-bold">
              Gestión
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;